<template>
	<div>
		<el-container style="flex-direction: column;">
			<!-- <MachMonitor></MachMonitor> -->
      <NJNav></NJNav>
			
			<div class="charts-box">
        <div class="tab-box">
				<div class="times">
					<p>三合一监测收割机早稻收获作业统计</p>
          <!-- <p style="right: 0;">统计时间：{{njNum.begin_day}}-{{njNum.end_day}}</p> -->
					<p style="right: 0;top: 4vh;">说明：以下统计数据仅为农机购置与应用补贴物联网农机的收割作业面积<span>（统计时间：{{njNum.begin_day}}-{{njNum.end_day}}）</span></p>
				</div>
			</div>
				<div class="tab-boxs">
          <!--<ul :class="njClassName">
						<li v-for="(item, i) in itemList" @click="tabItemClick(item)" class="items" :class="[{ active: activeNames == item.machineName }]" :key="i">
							<b>{{ item.machineName }}</b>
							<p>{{ item.num }}<span>台</span></p>
							<p>{{ item.areaNum }}<span>亩</span></p>
						</li>
					</ul>-->
					<div class="nums statisticsNums">
						<div class="item-nums">
							<p>物联网监管总收割机数量</p>
							<p><span>{{ njNum.njNum }}</span>台</p>
						</div>
						<div class="item-nums">
							<p>累计收获总作业面积</p>
							<p><span>{{ njNum.totalArea }}</span>亩</p>
						</div>
						<div class="item-nums">
							<p>本省收割机数量</p>
							<p><span>{{ njNum.localNjNum }}</span>台</p>
						</div>
						<div class="item-nums">
							<p>累计收获总作业面积</p>
							<p><span>{{ njNum.localTotalArea }}</span>亩</p>
						</div>
						<div class="item-nums">
							<p>跨区收割机数量</p>
							<p><span>{{ njNum.kqNjNum }}</span>台</p>
						</div>
						<div class="item-nums">
							<p>跨区收获总作业面积</p>
							<p><span>{{ njNum.kqTotalArea }}</span>亩</p>
						</div>
					</div>
				</div>
				<el-radio-group v-model="tabValue"  class="tabRadio">
          <el-radio-button label="0">按时间统计</el-radio-button>
          <el-radio-button label="1">按地区统计</el-radio-button>
        </el-radio-group>
				<div class="select-block">
					<HarvestStatisticsByTime v-if="tabValue == 0"></HarvestStatisticsByTime>
					<HarvestStatisticsByArea v-else></HarvestStatisticsByArea>
				</div>
			</div>
		</el-container>
	</div>
</template>

<script>
	import "echarts/map/js/china.js"
	import Api from "../../Serves/net-api.js";
	import Http from "../../Serves/net-http.js";
  import NJNav from '../Index/view/NJNav'
	import HarvestStatisticsByArea from "./HarvestStatisticsByArea.vue"
	import HarvestStatisticsByTime from "./HarvestStatisticsByTime.vue"
	
	import { mapState, mapActions, mapMutations } from "vuex";
	export default {
		name: "HarvestStatistics",
		components: {
			NJNav,
			HarvestStatisticsByArea,
			HarvestStatisticsByTime
		},
		data() {
			return {
				tabValue:'0',
				Citychars: "",
        itemList: [],
				njNum: {
					njNum:0,
					totalArea:0,
					localNjNum:0,
					localTotalArea:0,
					kqNjNum:0,
					kqTotalArea:0,
				},
				njNumList2: [],
				activeNames: '全部机具',
        tabDataList: [],
        njClassName: ''
			}
		},
		mounted() {
      this.statisticMachine()
		},
		methods: {
      // 总体统计数据
			statisticMachine() {
				let this_ = this;
				var url = Http.test + '/screenBuyNj/getAreaStatisticHarvester'
				Api.doPost(url, null, false, res => {
          this.njNum = res.result
        })
      },
     
			timeFormat(date) {
				if(!date || typeof date === 'string') {
					this.error('参数异常，请检查...')
				}
				var y = date.getFullYear() // 年
				// this.yearValue = y
				var m = date.getMonth() + 1 // 月
				var d = date.getDate() // 日
				if(m >= 1 && m <= 9) {
					m = '0' + m
				}
				if(d >= 1 && d <= 9) {
					d = '0' + d
				}
				return y + '-' + m + '-' + d
			},
			// 获取本年第一个月
			getFirstDayOfYear(date) {
				date.setDate(1)
				date.setMonth(0)
				return this.timeFormat(date)
			},
			// 获取当前日期
			getNowFormatDates() {
				var date = new Date()
				// var seperator1 = '-'
				var year = date.getFullYear()
				var month = date.getMonth() + 1
				var strDate = date.getDate()
				if(month >= 1 && month <= 9) {
					month = month
				}
				if(strDate >= 0 && strDate <= 9) {
					strDate = '0' + strDate
				}
				// var currentdate = year + seperator1 + month + seperator1 + strDate
        // var currentdate = year + '年' + month + '月' + strDate + '日'
        var currentdate = month + '月' + strDate + '日'
				return currentdate
			}
		}
	};
</script>
<style scoped>
	/*p {
		color: #fff;
	}
	*/
	.toolStatistics {
		width: 100%;
		height: 72vh;
	}
	.charts-box {
		width: 98%;
    height: 83vh;
		background-image: url('/static/img/zuoyejindu-bg.png');
		background-size: 100% 100%;
		background-repeat: no-repeat;
		position: relative;
		margin-left: 1%;
    margin-top: 1vh;
	}
	/* @media screen and (max-width: 1540px) {
		.charts-box {
			height: 89vh;
		}
	}
	.select-block-pro {
		width: 100%;
		height: 70vh;
	} */
	.select-block {
		width: 100%;
		height: 55vh;
	}
	#ToolChart {
		width: 100%;
		height: 57vh;
		margin-left: 1%;
	}
	.tab-box {
		width: 98%;
		margin-left: 1%;
		/* margin-bottom: 10px; */
		/* margin-top: 20px; */
		/* display: flex; */
	}
	
	.tab-boxs {
		width: 98%;
		margin-left: 1%;
		display: flex;
		/* background: #0B1640; */
		    padding-top: 1vh;
		/* justify-content: space-between; */
	}
	
	.tablist_box {
		width: 100%;
	}
	
	.tablist_item {
		width: 100%;
		display: flex;
		position: relative;
		margin-top: -14px;
		/* padding-left: 20px; */
	}
	
	.nums {

		display: flex;
		margin-top: 10px;
		color: #439BFF;
	}
	
	.item-nums {
		width: 15%;
	}
	/*.item-nums:nth-child(1){
    margin-right: 4vw;
    padding-left: 1vw;
  }
  .item-nums:nth-child(2){
    margin-right: 5vw;
  }
  .item-nums:nth-child(3){
    margin-right: 2.5vw;
  }*/
	
	.item-nums span:nth-child(2) {
		font-size: 0.8vw;
	}
	
	.item-nums span:nth-child(1) {
		font-size: 1.3vw;
	}
	
	.item-numss {
		width: 9.7%;
		width: 15%;
	}
	
	.item-numss:nth-child(1) {
		margin-right: 4vw;
		padding-left: 1vw;
	}
	
	.item-numss:nth-child(2) {
		margin-right: 5vw;
	}
	
	.item-numss:nth-child(3) {
		margin-right: 2.5vw;
	}
	
	.item-numss span:nth-child(2) {
		font-size: 0.8vw;
	}
	
	.item-numss span:nth-child(1) {
		font-size: 1.3vw;
	}
  .tabRadio {
    margin-left: 1%;
    margin-top: 1vh;
  }
	
</style>


// WEBPACK FOOTER //
// src/components/TableList/HarvestStatistics.vue